// Define importance levels with their rewards
export const IMPORTANCE = {
  HIGH: {
    value: 'high',
    label: 'High Impact',
    reward: 0.10, // 10% of dev pool
    bountyBps: 1000, // 10% in basis points
  },
  MEDIUM: {
    value: 'medium',
    label: 'Medium Impact',
    reward: 0.05, // 5% of dev pool
    bountyBps: 500, // 5% in basis points
  },
  LOW: {
    value: 'low',
    label: 'Low Impact',
    reward: 0.01, // 1% of dev pool
    bountyBps: 100, // 1% in basis points
  }
} as const;

export type ImportanceLevel = keyof typeof IMPORTANCE; 